import { render, staticRenderFns } from "./PatientCreateInfo.vue?vue&type=template&id=d3765752"
import script from "./PatientCreateInfo.vue?vue&type=script&lang=js"
export * from "./PatientCreateInfo.vue?vue&type=script&lang=js"
import style0 from "./PatientCreateInfo.vue?vue&type=style&index=0&id=d3765752&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports